import {MessageGroupViewModel} from './MessageGroupViewModel';
import {QuickReplyDto} from '../dto/QuickReplyDto';

export class DialogViewModel {
    constructor(public messageGroups: MessageGroupViewModel[] = [],
                public quickReplies?: QuickReplyDto[]) {
    }
}
